import { Container, Alert } from "react-bootstrap";
import HeaderWithTitle from "./HeaderWithTitle";

interface IProps {
    title: string;
    subTitle: string;
    alertVariant: string;
    message: string;
}
export default function ActionResultMessage(props: IProps) {

    return (
        <Container>
        <HeaderWithTitle title={props.title} subTitle={props.subTitle} contactMessage={false} />
        <Alert variant={props.alertVariant}>
            {props.message}
        </Alert>
    </Container>
    );
}
